import { logger } from '../logger/logger'

export const checkForNumberOfBets = (currentBets, choosenNumberOfBets) => {
  if (choosenNumberOfBets > 0) {
    if (currentBets >= choosenNumberOfBets) {
      return true
    }
  }
}

export const checkForStopOnLoss = (stopOnLoss, ggr) => {
  if (stopOnLoss > 0 && ggr < 0) {
    var _ggr = -ggr
    if (_ggr >= stopOnLoss) {
      logger.log('stop ggr = ' + ggr + ', stopOnLoss = ' + stopOnLoss)
      return true
    }
  }
}

export const checkForStopOnWin = (stopOnWin, ggr) => {
  if (stopOnWin > 0 && ggr > 0) {
    if (ggr >= stopOnWin) {
      logger.log('stop ggr=' + ggr + ', stopOnWin=' + stopOnWin)
      return true
    }
  }
}

export const checkForMaxBet = (bet, maxBet) => {
  if (bet > maxBet) {
    logger.log('bet, maxbet', bet, maxBet)
    return true
  }
}
